/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-indent */
import { useTranslate } from 'hooks/useTranslate';
import { FC, ReactElement, useMemo } from 'react';

import { formatNumber } from 'utils/formats';

import Page from 'modules/_shared/components/Pages/Page';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';

import EncumbranceDetailsPageBody from './components/EncumbranceDetailsPageBody';
import { useEncumbranceDetailsPage } from './context/EncumbranceDetailsPageContext';

import './EncumbranceDetails.scss';

import {
  EncumbranceOption,
  encumbranceOptions,
} from '../../constants/encumbranceOptions';

const EncumbranceDetails: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useEncumbranceDetailsPage();

  const pageActions: ReactElement[] = [
    <GoBackButton key="go-back" />,
    ...(data.hasLinkedShare
      ? [
          <Button
            key="edit-encumbrance"
            onClick={actions.handleEditEncumbrance}
            text={t('Edit')}
            disabled={data.isReadOnly}
          />,
        ]
      : []),
    <Button
      key="remove-encumbrance"
      variant={ButtonVariants.DANGER}
      onClick={actions.handleRemoveEncumbrance}
      text={t('Remove')}
      disabled
    />,
  ];

  const encumbranceLabel = useMemo(() => {
    const selectedEncumbrance = encumbranceOptions.find(
      (option) => option.value === data?.type
    ) as EncumbranceOption | undefined;

    return selectedEncumbrance ? selectedEncumbrance.label : '';
  }, [data?.type]);

  return (
    <Page>
      <PageListHeader
        subTitle={t('EncumbranceDetails')}
        subTitleSuffix={t(`ShareEncumbranceOption_${encumbranceLabel}`)}
        description={
          <span className="text-base">
            {t('Range')}:&nbsp;
            <b>{`${formatNumber(data.from)} - ${formatNumber(data.to)}`}</b>
          </span>
        }
        actions={data.isAdmin && !data.isReadOnly ? pageActions : []}
      />

      {!data.hasLinkedShare && (
        <div className="alert alert-warning alert-icon w-100 mb-2" role="alert">
          <em className="icon ni ni-alert-circle" />
          <p className="mb-0">{t('EncumbranceHistoricalInfo')}</p>
        </div>
      )}

      <EncumbranceDetailsPageBody />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default EncumbranceDetails;
